export default "__VITE_ASSET__3bfab976__"